import { useIntl } from "react-intl";
import { useState } from "react";
import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';

interface CancelModalProps {
  openCancelBudgetModal: boolean;
  setOpenCancelBudgetModal: (open: boolean) => void;
  cancelBudget:(value:boolean)=>void;
  editMode: boolean;
}

export default function CancelBudgetModal({openCancelBudgetModal, setOpenCancelBudgetModal ,cancelBudget, editMode}: CancelModalProps) {

  const dispatch = useDispatch();
  const intl = useIntl();
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <Modal
      visible={openCancelBudgetModal}
      setVisible={setOpenCancelBudgetModal}
      className="nv-scope nv-dialog custom-modal w-auto"
      header={<span className="nv-modal-title">{`¿Querés cancelar${editMode?' la edicion de':''} este presupuesto?`}</span>}
      footerButtonRightText = {intl.formatMessage({ id: "YesCancel" })}
      footerButtonLeftText= {intl.formatMessage({ id: "ContinueWithLoad" })}
      onClickLeftBtn = {()=>cancelBudget(false)}
      onClickRightBtn={()=>cancelBudget(true)}
      closable={false}
    >
      <div style={{ minWidth: isMobile ? "" : "150px" }}>
        <div className="flex flex-column gap-2">
          <span>{intl.formatMessage({ id: "UponCancellationTheDataEnteredWillBeLost" })}</span>
        </div>
      </div>
    </Modal>
  );
}
